import { render, staticRenderFns } from "./TeacherTableDraggable.vue?vue&type=template&id=840b312c&scoped=true"
import script from "./TeacherTableDraggable.vue?vue&type=script&lang=js"
export * from "./TeacherTableDraggable.vue?vue&type=script&lang=js"
import style0 from "./TeacherTableDraggable.vue?vue&type=style&index=0&id=840b312c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840b312c",
  null
  
)

export default component.exports